import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  padding: 24px 16px;
  background-color: #1c1c1c;
  border-radius: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  margin-bottom: 15px;
`;

const MedalIcon = styled.div`
  position: absolute;
  top: 0;
  right: 26px;
`;

const TextContainer = styled.div`
  margin-right: 24px;
  h4 {
    margin: 0;
    font-family: "Gilroy";
    font-weight: bold;
    margin-bottom: 8px;
    color: white;
  }
  p {
    margin: 0;
  }
`;

const Rank = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-right: 16px;
  h5 {
    margin: 0;
    margin-bottom: -8px;
    font-size: 48px;
    font-weight: bold;
    font-family: "Gilroy";
  }
  p {
    margin: 0;
    font-weight: bold;
    font-family: "Gilroy";
  }
`;

export default function LeaderboardCard({ playerRank }) {
  return (
    <Container>
      <TextContainer>
        <h4>LEADERBOARD</h4>
        <p>Your current</p>
        <p>standing</p>
      </TextContainer>
      <Rank>
        <h5>{playerRank}</h5>
      </Rank>
      <MedalIcon>
        <svg
          width="40"
          height="47"
          viewBox="0 0 40 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 0H0L13.0001 23.0003L27.0001 23.0004L14 0Z"
            fill="#0088D2"
          />
          <path
            d="M26 0.000244141H40L27.5 23.0002L20 10.0002L26 0.000244141Z"
            fill="#0088D2"
          />
          <circle cx="20.5" cy="35.5" r="11.5" fill="#FDC32D" />
        </svg>
      </MedalIcon>
    </Container>
  );
}

LeaderboardCard.defaultProps = {
  playerRank: 23,
  totalPlayers: 1405,
};
